import { useState, useEffect } from 'react';
import { ApiGet } from '../Api';
import logo from './jofood_logo.png';
import TopBar from '../TopBar';
import { titleColor, backgroundMainColor, backgroundSubColor } from '../Color';
import PaginationGrid from '../../src/PaginationGrid';

function WeightSorting() {
  let intervalId;
  useEffect(() => {
    document.title = 'JOFOOD MONITORING';

    Inquiry();

    intervalId = setInterval(()=>{
      Inquiry();
    }, 1000 * 60);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  const [headerData, setHeaderData] = useState({ todayProduction: { pass_qty: 0, fail_qty: 0 }, weightSorting1: { pass_cnt: 0, fail_cnt: 0 }, weightSorting2: { pass_cnt: 0, fail_cnt: 0 } });
  async function Inquiry() {
    const response = await ApiGet(`${process.env.REACT_APP_API_DOMAIN}jo-food/weight-sorting/header`);
    if (response !== null && response.ok) {
      const json = await response.json();
      setHeaderData(json);
    }
  }

  const logoContent = (
    <img src={logo} width={'40px'} height={'40px'} style={{ marginLeft: 10, marginTop: 10 }} />
  );

  return (
    <div style={{ width: '100vw', height: '100vh' }} onContextMenu={(event)=>{ event.preventDefault(); }}>
      <TopBar logo={logoContent} title={''} />

      <div style={{  width: 'calc(100% - 40px)', height: 300, backgroundColor: backgroundMainColor, padding: 20 }}>
        <div style={{  display: 'grid', gap: 30, width: '100%', height: '100%', gridTemplateColumns: 'repeat(3, 1fr)' }}>
          {/*금일생산량*/}
          <div style={{ display: 'grid', gap: 10, width: '100%', height: '100%', gridTemplateColumns: 'repeat(2, 1fr)', backgroundColor: backgroundMainColor }}>
            <div style={{ backgroundColor: backgroundSubColor, borderRadius: 10, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 40, fontWeight: 'bold', color: titleColor }}>
              금일생산량
            </div>

            <div style={{ display: 'grid', gap: 10, width: '100%', height: '100%', gridTemplateRows: 'repeat(2, 1fr)', backgroundColor: backgroundMainColor, borderRadius: 10, width: '100%', height: '100%'}}>
              <div style={{ backgroundColor: backgroundSubColor, borderRadius: 10, width: '100%', height: '100%', fontSize: 35, fontWeight: 'bold' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: titleColor }}>
                  양품수량
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: 'rgb(255, 255, 102)' }}>
                  {headerData.todayProduction.pass_qty.toLocaleString()}
                </div>
              </div>
              
              <div style={{ backgroundColor: backgroundSubColor, borderRadius: 10, width: '100%', height: '100%', fontSize: 35, fontWeight: 'bold' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: titleColor }}>
                  불량수량
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: 'rgb(255, 255, 102)' }}>
                  {headerData.todayProduction.fail_qty.toLocaleString()}
                </div>
              </div>
            </div>
          </div>

          {/*중량선별기 1호*/}
          <div style={{ display: 'grid', gap: 10, width: '100%', height: '100%', gridTemplateColumns: 'repeat(2, 1fr)', backgroundColor: backgroundMainColor }}>
            <div style={{ backgroundColor: backgroundSubColor, borderRadius: 10, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 40, fontWeight: 'bold', color: titleColor }}>
              중량선별기 1호
            </div>

            <div style={{ display: 'grid', gap: 10, width: '100%', height: '100%', gridTemplateRows: 'repeat(2, 1fr)', backgroundColor: backgroundMainColor, borderRadius: 10, width: '100%', height: '100%'}}>
              <div style={{ backgroundColor: backgroundSubColor, borderRadius: 10, width: '100%', height: '100%', fontSize: 35, fontWeight: 'bold' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: titleColor }}>
                  합격
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: 'rgb(255, 255, 102)' }}>
                  {headerData.weightSorting1.pass_cnt.toLocaleString()}
                </div>
              </div>
              
              <div style={{ backgroundColor: backgroundSubColor, borderRadius: 10, width: '100%', height: '100%', fontSize: 35, fontWeight: 'bold' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: titleColor }}>
                  불합격
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: 'rgb(255, 255, 102)' }}>
                  {headerData.weightSorting1.fail_cnt.toLocaleString()}
                </div>
              </div>
            </div>
          </div>

          {/*중량선별기 2호*/}
          <div style={{ display: 'grid', gap: 10, width: '100%', height: '100%', gridTemplateColumns: 'repeat(2, 1fr)', backgroundColor: backgroundMainColor }}>
            <div style={{ backgroundColor: backgroundSubColor, borderRadius: 10, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 40, fontWeight: 'bold', color: titleColor }}>
              중량선별기 2호
            </div>

            <div style={{ display: 'grid', gap: 10, width: '100%', height: '100%', gridTemplateRows: 'repeat(2, 1fr)', backgroundColor: backgroundMainColor, borderRadius: 10, width: '100%', height: '100%'}}>
              <div style={{ backgroundColor: backgroundSubColor, borderRadius: 10, width: '100%', height: '100%', fontSize: 35, fontWeight: 'bold' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: titleColor }}>
                  합격
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: 'rgb(255, 255, 102)' }}>
                  {headerData.weightSorting2.pass_cnt.toLocaleString()}
                </div>
              </div>
              
              <div style={{ backgroundColor: backgroundSubColor, borderRadius: 10, width: '100%', height: '100%', fontSize: 35, fontWeight: 'bold' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: titleColor }}>
                  불합격
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%', color: 'rgb(255, 255, 102)' }}>
                  {headerData.weightSorting2.fail_cnt.toLocaleString()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ backgroundColor: backgroundMainColor, width: 'calc(100% - 40px)', height: 'calc(100% - 440px)', padding: 20 }}>
        <PaginationGrid mainHeight={0} inquiryInterval={30} notNumberColumnArray={['품번']} apiUrl={`${process.env.REACT_APP_API_DOMAIN}jo-food/weight-sorting/detail?`} />
      </div>
    </div>
  );
}

export default WeightSorting;